import {
  fetchParticipatedFormCoversThunk,
  participatedFormCoversSelectors,
} from '@/redux/slices/participatedFormCoversSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { useCallback, useEffect, useMemo } from 'react'
import ParticipatedFormList from './ParticipatedFormList'

export default function ParticipatedForms() {
  const dispatch = useAppDispatch()
  const participatedForms = useAppSelector(participatedFormCoversSelectors.selectAll)
  const isLoading = useAppSelector(state => state.participatedFormCovers.isLoading)
  const pageInfo = useAppSelector(state => state.participatedFormCovers.pageInfo)

  const isEmpty = participatedForms.length === 0

  const formIds = useMemo(() => participatedForms.map(form => form.form.token), [participatedForms])

  const fetchParticipatedForms = useCallback(
    (reset?: boolean) => {
      dispatch(fetchParticipatedFormCoversThunk({ reset }))
    },
    [dispatch]
  )

  useEffect(() => {
    fetchParticipatedForms(true)
  }, [fetchParticipatedForms])

  const handleRefresh = useCallback(() => {
    fetchParticipatedForms(true)
  }, [fetchParticipatedForms])

  const handleLoadMore = useCallback(() => {
    fetchParticipatedForms(false)
  }, [fetchParticipatedForms])

  return (
    <ParticipatedFormList
      formIds={formIds}
      isLoading={isLoading}
      hasNextPage={pageInfo.hasNextPage}
      isEmpty={isEmpty}
      onLoadMore={handleLoadMore}
      onRefresh={handleRefresh}
    />
  )
}
